import { render, staticRenderFns } from "./CompanyLimitPerUser.vue?vue&type=template&id=05bfbfd5&"
import script from "./CompanyLimitPerUser.vue?vue&type=script&lang=js&"
export * from "./CompanyLimitPerUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports